<div class="productDetails" *ngIf="product">
  <div class="productDetails__top">
    <div class="productDetails__resume">
      <div *ngIf="isSeller" class="productDetails__resume__sellerActions sellerActions">
        <p
          *ngIf="isInCourseOfPurchase"
          class="sellerActions__info sellerActions__info--sold"
          i18n="@@PRODUCT.DETAILS.SELLER_ACTIONS.SOLD_TEXT"
        >
          Your item is being ordered.
        </p>
        <p
          *ngIf="product.sold"
          class="sellerActions__info sellerActions__info--itemSold"
          i18n="@@PRODUCT.DETAILS.SELLER_ACTIONS.ITEM_SOLD"
        >
          Congratulations {{ product.seller.firstname }}! A customer has purchased your item.
        </p>

        <div *ngIf="!product.sold" class="sellerActions__list sellerActions__list--onSale">
          <button class="sellerActions__btn" [disabled]="isInCourseOfPurchase" (click)="openAddPhotoModal()">
            <i class="sellerActions__btn__icon sellerActions__btn__icon--addPictures"></i>
            <span class="sellerActions__btn__text" i18n="@@PRODUCT.DETAILS.SELLER_ACTIONS.NEW_PICTURES"
              >Add new pictures</span
            >
          </button>

          <vc-ref
            i18n-resource="@@LINKS.SELLER_DECREASE_PRICE"
            resource="/drop-the-price/?id_produit={{ product.id }}"
            [ngClass]="{disabled: isInCourseOfPurchase}"
          >
            <div class="sellerActions__btn">
              <i class="sellerActions__btn__icon sellerActions__btn__icon--decreasePrice"></i>
              <span class="sellerActions__btn__text" i18n="@@PRODUCT.DETAILS.SELLER_ACTIONS.DECREASE_PRICE"
                >Drop the price</span
              >
            </div>
          </vc-ref>

          <vc-ref
            i18n-resource="@@LINKS.SELLER_REMOVE_FROM_SELL"
            resource="/remove-from-sale/?id_produit={{ product.id }}"
            [ngClass]="{disabled: isInCourseOfPurchase}"
          >
            <div class="sellerActions__btn">
              <i class="sellerActions__btn__icon sellerActions__btn__icon--delete"></i>
              <span class="sellerActions__btn__text" i18n="@@PRODUCT.DETAILS.SELLER_ACTIONS.REMOVE_FROM_SELL"
                >Remove from sale
              </span>
            </div>
          </vc-ref>
        </div>

        <div *ngIf="product.sold" class="sellerActions__list sellerActions__list--sold">
          <!--
            <vc-ref *ngIf="shippingVoucherPath" class="sellerActions__soldBtn sellerActions__soldBtn--downloadShippingVoucher vc-btn vc-btn--primary vc-btn--full vc-btn-md--notfull "
            resource={{shippingVoucherPath}} i18n="@@PRODUCT.DETAILS.SELLER_ACTIONS.DOWNLOAD_SHIPPING_VOUCHER">Download
            the voucher</vc-ref>
          -->

          <vc-ref
            [anchor]="!disableBtnCancelMySale"
            [disableLink]="disableBtnCancelMySale"
            *ngIf="!product.receipt"
            class="sellerActions__soldBtn sellerActions__soldBtn--cancelTheSale vc-btn vc-btn--primary vc-btn--full vc-btn--notfull--md-up "
            i18n-resource="@@PRODUCT.DETAILS.SELLER_ACTIONS.CANCEL_SELL_LINK"
            resource="/cancel-my-sale/?id_produit={{ product.id }}"
            i18n="@@PRODUCT.DETAILS.SELLER_ACTIONS.CANCEL_THE_SALE"
            (click)="setStartDateCancelMySale()"
            [ngClass]="{disabled: disableBtnCancelMySale}"
            >Item unavailable ?</vc-ref
          >
        </div>
        <!--
          // Temporarily hide On Going negotiation CTA
          <vc-ref *ngIf="negotiation && isSeller" class="sellerActions__mmaoButton vc-btn vc-btn--primary--outline vc-btn--full vc-btn-md--notfull" i18n-resource="@@LINKS.SELLER_SEE_CURRENT_NEGOCIATIONS" resource="/my-account.shtml#commandes|sales-negotiations" i18n="@@PRODUCT.DETAILS.SELLER_ACTIONS.SEE_CURRENT_NEGOCIATIONS">Ongoing negotiations</vc-ref>
        -->
      </div>

      <p *ngIf="product?.inStock" class="productDetails__resume__express">
        <vc-sprite-icons name="express" class="productDetails__resume__express__icon"></vc-sprite-icons>
        <span i18n="@@DELIVERY_OPTS.EXPRESS">Express Delivery</span>
      </p>

      <vc-product-price
        class="productDetails__resume__price"
        [product]="product"
        [displayTaxInfo]="displayTaxeInfo"
      ></vc-product-price>

      <vc-product-authentication-infos
        *ngIf="!directShippingEligible"
        [isExpressDelivery]="product?.inStock"
        class="productDetails__resume__contextual productDetails__resume__contextual--authentication"
      ></vc-product-authentication-infos>

      <ng-container *ngIf="directShippingEligible">
        <ng-container *ngIf="sustainableLeafOn; else ancientDSBloc">
          <p class="productDetails__resume__contextual productDetails__resume__contextual--directShipping vc-text-m">
            <vc-sprite-icons class="productDetails__resume__contextual__icon" name="handshake"></vc-sprite-icons>
            <span i18n="@@PDP_DS.SUSTAINABLE_LEAF.TITLE" class="productDetails__resume__contextual__title vc-text-l"
              >Direct Shipping</span
            >
            <button
              class="productDetails__resume__contextual__button"
              (click)="openDeliveryServiceDescriptionPopin(directShippingPopinContext)"
            >
              <ng-container *ngIf="isDirectShippingTaxes; else dsTextNoTax">
                <span
                  class="productDetails__resume__contextual__text"
                  i18n="@@PDP_DS.SUSTAINABLE_LEAF.TEXT_CROSSBORDER"
                >
                  Cut your item's journey in half to save on CO2 and costs. Tax and duties may apply.</span
                >
              </ng-container>
              <ng-template #dsTextNoTax>
                <span class="productDetails__resume__contextual__text" i18n="@@PDP_DS.SUSTAINABLE_LEAF.TEXT">
                  Cut your item’s journey in half to save on CO2 and costs.</span
                > </ng-template
              >&nbsp;<span
                i18n="@@PDP_DS.SUSTAINABLE_LEAF.CTA"
                class="productDetails__resume__contextual__link vc-text-s"
                >Learn More</span
              >
            </button>
            <span class="productDetails__resume__contextual__sustainable">
              <vc-sprite-icons
                name="sustainable-leaf"
                class="productDetails__resume__contextual__sustainable__icon"
              ></vc-sprite-icons>
              <span i18n="@@PDP_DS.SUSTAINABLE_LEAF.TITLE2"><span lang="en">Sustainable</span></span>
            </span>
          </p>
        </ng-container>
        <ng-template #ancientDSBloc>
          <button
            *ngIf="directShippingEligible"
            class="productDetails__resume__contextual productDetails__resume__contextual--directShippingOld vc-body3"
            (click)="openDeliveryServiceDescriptionPopin(directShippingPopinContext)"
          >
            <vc-sprite-icons class="productDetails__resume__contextual__icon" name="handshake"></vc-sprite-icons>
            <ng-container *ngIf="isDirectShippingTaxes; else ancientDSTextNoTax">
              <span
                class="productDetails__resume__contextual__text"
                i18n="@@PRODUCT.DETAILS.DIRECT_SHIPPING_BUTTON_CROSSBORDER"
                >Eligible for Direct Shipping. Tax and duties may apply.&nbsp; <b>Learn More</b></span
              >
            </ng-container>
            <ng-template #ancientDSTextNoTax>
              <span class="productDetails__resume__contextual__text" i18n="@@PRODUCT.DETAILS.DIRECT_SHIPPING_BUTTON"
                >Eligible to Direct Shipping. <b>Free shipping</b>&nbsp; <b>Learn More</b></span
              >
            </ng-template>
          </button>
        </ng-template>
      </ng-container>

      <div class="productDetails__resume__characteristics">
        <p *ngIf="product?.size?.size">
          {{ product.size.size }}
          <span *ngIf="product.size.localizedStandard">{{ product.size.localizedStandard }}</span>
          <button
            *ngIf="sizeGuide?.guide.length > 0"
            (click)="openSizeGuideModal()"
            class="productDetails__moreInfoLink"
            i18n="@@PRODUCT.DETAILS.SIZES_GUIDE"
          >
            size guide
          </button>
        </p>

        <p *ngIf="product?.condition?.description">
          <span>{{ product?.condition.description }}</span>
          <button
            class="productDetails__moreInfoLink"
            (click)="conditionGuideModalComponent()"
            i18n="@@PRODUCT.DETAILS.MORE_INFO"
          >
            More infos
          </button>
        </p>

        <p *ngIf="product.color?.localizedName">
          {{ product?.color?.localizedName }} <span *ngIf="product.color?.localizedName">, </span>
          <span *ngIf="product.material?.parent?.localizedName; else material">{{
            product.material.parent.localizedName
          }}</span>
          <ng-template #material>
            <span *ngIf="product.material?.localizedName">{{ product?.material.localizedName }}</span>
          </ng-template>
        </p>
      </div>
    </div>

    <div *ngIf="product.seller" class="productDetails__seller">
      <vc-product-seller-badge class="productDetails__sellerBadge" [seller]="product.seller"></vc-product-seller-badge>
      <div class="productDetails__sellerText">
        <vc-ref
          class="productDetails__sellerText__link"
          [anchor]="false"
          i18n-resource="@@PRODUCT.DETAILS.SELLER_PROFILE_LINK"
          resource="/members/profile-{{ product.seller.id }}.shtml"
        >
          <ng-container *ngIf="!isOfficialStore" i18n="@@PRODUCT.DETAILS.SELLING_BY">Listed for sale by</ng-container>
          {{ product.seller.firstname }}
        </vc-ref>
        <vc-ref
          *ngIf="product.consignment && !(product.consignment && product.seller.internalAccount) && !isOfficialStore"
          [anchor]="false"
          i18n-resource="@@CONSIGNMENT.SERVICE.LINK"
          resource="/consignment.shtml"
          (click)="trackConsignmentClick()"
        >
          <span class="productDetails__sellerText__consignment">
            <ng-container i18n="@@CONSIGNMENT.SERVICE">via our Concierge Service</ng-container>
          </span>
        </vc-ref>
      </div>
    </div>
  </div>

  <vc-product-installment
    *ngIf="!directShippingEligible"
    class="productDetails__resume__installment"
    [product]="product"
  ></vc-product-installment>

  <div class="productDetails__welcomeVoucher" *ngIf="welcomeVoucher && isShippable && !product.sold">
    <vc-sprite-icons class="productDetails__welcomeVoucher__icon" name="present"></vc-sprite-icons>
    <span i18n="@@PRODUCT.DETAILS.WELCOME_VOUCHER"
      >{{ welcomeVoucher.discount.formatted }} discount with the code* <b>{{ welcomeVoucher.voucherCode }}</b></span
    >
    <button
      class="tooltipContainer tooltipContainer--jsToggle productDetails__welcomeVoucher__tooltip"
      [class.tooltipContainer--active]="isWelcomeVoucherInfosActive"
      (click)="toogleWelcomeVoucherinfo()"
      (focusout)="closeWelcomeVoucherinfo()"
    >
      <vc-sprite-icons name="info" class="productDetails__welcomeVoucher__tooltipIcon"></vc-sprite-icons>
      <div class="tooltip tooltip--left" i18n="@@PRODUCT.DETAILS.WELCOME_VOUCHER_TOOLTIP">
        * This offer is valid once per person with the code {{ welcomeVoucher.voucherCode }} and can be used on all
        orders placed through the Vestiaire Collective App with a minimum purchase of
        {{ welcomeVoucher.threshold.formatted }}. Offer is non-exchangeable, non-refundable and not valid with any other
        discount or offer. Simply enter the code at the checkout.
      </div>
    </button>
  </div>

  <div
    class="productDetails__prohibitedMessage"
    [ngClass]="{
      'productDetails__prohibitedMessage--covid':
        !isSeller && shipping?.prohibited && shipping?.prohibitedReason === 'covid'
    }"
    *ngIf="!isSeller && shipping?.prohibited"
  >
    <span *ngIf="shipping?.prohibitedReason === 'covid'; else prohibitedMessageDefault">
      <span i18n="@@PRODUCT.DETAILS.PROHIBITED_MESSAGE_COVID"
        ><b>Due to the current COVID-19 situation,</b> we're unable to ship this item at the moment.</span
      >
      <a
        i18n-routerLink="@@PRODUCT.DETAILS.PROHIBITED_MESSAGE_LINK.URL"
        routerLink="/journal/covid-19-our-faqs/"
        i18n="@@PRODUCT.DETAILS.PROHIBITED_MESSAGE_LINK.TEXT"
        target="_blank"
        rel="noopener"
        class="vc-link productDetails__prohibitedMessage__link"
        >Learn more</a
      >
    </span>
    <ng-template #prohibitedMessageDefault>
      <span i18n="@@PRODUCT.DETAILS.PROHIBITED_MESSAGE">
        Unfortunately, due to shipping restrictions this item cannot be shipped to your country.
      </span>
    </ng-template>
  </div>

  <div *ngIf="isSellerOnVacation && !shipping?.prohibited" class="productDetails__sellerVacation vc-text-m">
    <h4 class="productDetails__sellerVacation__title" i18n="@@PRODUCT.DETAILS.SELLER_VACATION.TITLE">
      Item temporary not available
    </h4>
    <p i18n="@@PRODUCT.DETAILS.SELLER_VACATION.TEXT">
      This item cannot be bought due to the temporary unavailability of the seller. Come back later to check if it's
      available again.
    </p>
  </div>

  <!-- ======================== CTA : BEGIN ======================== -->
  <div
    class="reservedProduct"
    [ngClass]="{'reservedProduct--toMe': reservation.reservedToMe}"
    *ngIf="!isSeller && isReserved"
  >
    <span *ngIf="reservation.reservedToMe" i18n="@@PRODUCT.DESCRIPTION.DETAILS.MODAL.ADD_TO_CART_PREMIUM"
      >This item is in your cart. It is reserved for {{ reservationExpirationDate | appDateInterval }} thanks to your
      Premium subscription.</span
    >
    <span *ngIf="reservation.premium" i18n="@@PRODUCT.DETAILS.RESERVATION.RESERVED_BY_PREMIUM"
      >This item is currently reserved by a Premium member.</span
    >

    <div class="reservedProductCta">
      <button
        class="vc-btn vc-btn--primary vc-btn--medium vc-btn--full vc-btn--notfull--md-up vc-btn--small"
        *ngIf="reservation.reservedToMe"
        i18n-routerLink="@@LINKS.FINISH_ORDER"
        routerLink="/shop-order.shtml"
        i18n="@@PRODUCT.DETAILS.CTA.FINISH_ORDER"
      >
        Complete your order
      </button>

      <button
        class="vc-btn vc-btn--secondary vc-btn--medium vc-btn--full vc-btn--notfull--md-up vc-btn--small"
        *ngIf="!isPremium"
        i18n-routerLink="@@LINKS.DISCOVER_PREMIUM"
        routerLink="/premium-subscription.shtml"
        i18n="@@PRODUCT.DETAILS.CTA.DISCOVER_PREMIUM"
      >
        Discover premium
      </button>
    </div>
  </div>

  <div
    *ngIf="canShowMessageBloc()"
    class="negotiationStatus__box clearfix"
    [ngClass]="{'negotiationStatus__box--accept': negotiation?.isAccepted}"
  >
    {{ negotiation.userMessage }}&nbsp;{{ negotiation.userSubMessage }}
    <a
      appOpenMmaoPopin
      class="negotiationStatus__link"
      [product]="product"
      [negotiation]="negotiation && negotiation.isClosed ? null : negotiation"
      i18n="@@MMAO.CTA.ENTER_AREA"
      >Enter the negotiating area</a
    >
  </div>
  <div
    class="product__cta"
    *ngIf="!isSeller"
    [ngClass]="{
      'product__cta--sellerVacation': isSellerOnVacation,
      'product__cta--chat': chat_from_pdp,
      'product__cta--chatException': isLogged && chat_from_pdp && !chatAllowed
    }"
  >
    <ng-container *ngIf="showBuyerCallToActions; else alwaysDisplayed">
      <button
        *ngIf="isSellerOnVacation"
        class="vc-btn vc-btn--outline vc-btn--full vc-btn--large product__ctaBtn product__ctaBtn--alert"
        [ngClass]="{'product__ctaBtn--alertCreated': isHolidaysEndAlertCreated}"
        [disabled]="!user"
        (click)="toggleHolidaysEndAlert()"
      >
        <ng-container *ngIf="isHolidaysEndAlertCreated; else toCreate">
          <vc-sprite-icons name="checkmark" class="product__ctaBtn__icon"></vc-sprite-icons>
          <span i18n="@@PRODUCT.DETAILS.CTA.ALERT_CREATED">Alert Created</span>
        </ng-container>
        <ng-template #toCreate>
          <ng-container *ngIf="holidaysEndAlertError; else defaultTxt">
            <span class="product__ctaBtn__error">{{ holidaysEndAlertError }}</span>
          </ng-container>
          <ng-template #defaultTxt>
            <span i18n="@@PRODUCT.DETAILS.CTA.CREATE_AN_ALERT">Create an alert</span>
          </ng-template>
        </ng-template>
      </button>
      <button
        [appAddToCart]="product"
        addToCartActive="hasLoader"
        class="vc-btn vc-btn--primary vc-btn--large vc-btn--full product__ctaBtn product__ctaBtn--main"
        [disabled]="!canAddToCart || isReserved || isSellerOnVacation"
        [withPopin]="true"
        (click)="trackAddToCart()"
      >
        <span
          *ngIf="negotiation && negotiation.isAccepted && !negotiation.isClosed"
          i18n="@@PRODUCT.DETAILS.CTA.BUY_WITH_PRICE"
        >
          Buy at {{ negotiation.price.formatted }}
        </span>
        <span
          *ngIf="!negotiation || !negotiation.isAccepted || (negotiation && negotiation.isClosed)"
          i18n="@@PRODUCT.DETAILS.CTA.BUY"
          >Add to bag</span
        >
      </button>
      <button
        *ngIf="!isSellerOnVacation"
        appOpenMmaoPopin
        (addNegotiation)="addNegotiation($event)"
        [product]="product"
        [negotiation]="negotiation?.isClosed ? null : negotiation"
        [disabled]="!canMakeAnOffer || isReserved || isSellerOnVacation"
        class="vc-btn vc-btn--outline vc-btn--full vc-btn--large product__ctaBtn product__ctaBtn--secondary product__ctaBtn--mmao"
        (click)="trackMmaoClick()"
        i18n="@@PRODUCT.DETAILS.CTA.NEGOCIATE"
      >
        Make an offer
      </button>
      <button
        *ngIf="chat_from_pdp && chatAllowed"
        appOpenChatPopin
        [product]="product"
        [chatFromPdp]="true"
        [disabled]="!isEligibleForChat"
        class="vc-btn vc-btn--outline vc-btn--full vc-btn--large product__ctaBtn product__ctaBtn--secondary"
        (click)="trackChatClick()"
      >
        <vc-sprite-icons name="chat" class="product__ctaBtn__icon"></vc-sprite-icons>
        <span i18n="@@PRODUCT.DETAILS.CTA.CHAT" class="product__ctaBtn__txt">Chat</span>
      </button>
    </ng-container>
    <!-- Twice because of UI requirements when MMAO and BUY buttons are displayed. But remains there despite showBuyerCallToActions cases -->
    <ng-template #alwaysDisplayed>
      <button
        *ngIf="chat_from_pdp && chatAllowed"
        appOpenChatPopin
        [product]="product"
        [chatFromPdp]="true"
        [disabled]="!isEligibleForChat"
        class="vc-btn vc-btn--outline vc-btn--full vc-btn--large"
        (click)="trackChatClick()"
      >
        <vc-sprite-icons name="chat" class="product__ctaBtn__icon"></vc-sprite-icons>
        <span i18n="@@PRODUCT.DETAILS.CTA.CHAT" class="product__ctaBtn__txt">Chat</span>
      </button>
    </ng-template>
  </div>

  <div [hidden]="true">
    <span i18n="@@PRODUCT.DETAILS.CTA.BUY">Add to bag</span>
    <span i18n="@@PRODUCT.DETAILS.CTA.BUY_WITH_PRICE">Buy at {{ price }}</span>
  </div>
  <!-- ======================== CTA : END ======================== -->

  <vc-product-bookmark-actions
    *ngIf="!product.sold"
    [product]="product"
    [isLogged]="isLogged"
    [isSeller]="isSeller"
  ></vc-product-bookmark-actions>

  <div class="additionalDetails">
    <div class="additionalDetails__item">
      <vc-sprite-icons name="pin" class="additionalDetails__icon additionalDetails__icon--pin"></vc-sprite-icons>
      <div class="additionalDetails__text">
        <span
          *ngIf="shipping && product.inStock; else productLocalisation"
          i18n="@@PRODUCT.DETAILS.PRODUCT_LOCALISATION_VC"
          >Vestiaire Collective {{ shipping.warehouse.localizedName }}</span
        >
        <ng-template #productLocalisation i18n="@@PRODUCT.DETAILS.PRODUCT_LOCALISATION"
          >{{ product.seller.country }}, from the seller {{ product.seller.firstname }}</ng-template
        >
        <button class="additionalDetails__link" (click)="openLocalisationModal()" i18n="@@PRODUCT.DETAILS.MORE_INFO">
          More infos
        </button>
      </div>
    </div>
    <div class="additionalDetails__item" *ngIf="product.inStock">
      <div *ngIf="shipping">
        <vc-sprite-icons
          name="box-clock"
          class="additionalDetails__icon additionalDetails__icon--delivery"
        ></vc-sprite-icons>
      </div>
      <div *ngIf="shipping" class="additionalDetails__text">
        <div *ngIf="product.inStock">
          <span class="" i18n="@@PRODUCT.DETAILS.DELIVERY_ESTIMATED"
            >Estimated delivery: {{ shipping.sendDelay }} day(s)</span
          >
          <button class="additionalDetails__link" (click)="openDeliveryModal()" i18n="@@PRODUCT.DETAILS.MORE_INFO">
            More infos
          </button>
        </div>
      </div>
    </div>
    <div class="additionalDetails__item">
      <vc-sprite-icons
        name="checkmark"
        class="additionalDetails__icon additionalDetails__icon--check"
      ></vc-sprite-icons>
      <div class="additionalDetails__text">
        <span
          *ngIf="product.inStock; else productComplianceAlreadyCheck"
          i18n="@@PRODUCT.DETAILS.QUALITY_CONTROL_ALREADY_DONE"
          >Quality control completed</span
        >
        <ng-template #productComplianceAlreadyCheck i18n="@@PRODUCT.DETAILS.QUALITY_CONTROL"
          >Quality control guaranteed</ng-template
        >
        <button class="additionalDetails__link" (click)="openControlQualityModal()" i18n="@@PRODUCT.DETAILS.MORE_INFO">
          More infos
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="product.editorDescription" class="editorsPick">
    <div class="editorsPick__title" i18n="@@PRODUCT.DETAILS.EDITOR_PICK.TITLE">Editor's Pick</div>
    <p class="editorsPick__text" [class.open]="isOpen">{{ product?.editorDescription }}</p>
    <button class="editorsPick__seeMore" (click)="toggleEditorsPick()">
      <span *ngIf="!isOpen" i18n="@@PRODUCT.DETAILS.EDITOR_PICK.SEE_MORE">Read more...</span>
      <span *ngIf="isOpen" i18n="@@PRODUCT.DETAILS.EDITOR_PICK.SEE_LESS">See Less</span>
    </button>
  </div>
</div>
